import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

/**
 * Hook to check if a team has any sites
 * @param {string} teamId - The team ID to check sites for
 * @returns {boolean} - True if the team has at least one site, false otherwise
 */
export function useTeamHasSites(teamId) {
  const [hasSites, setHasSites] = useState(false);

  useEffect(() => {
    if (!teamId) {
      setHasSites(false);
      return;
    }

    const db = firebase.firestore();
    const unsubscribe = db
      .collection('teams')
      .doc(teamId)
      .collection('sites')
      .limit(1)
      .onSnapshot(
        (snapshot) => {
          setHasSites(!snapshot.empty);
        },
        (error) => {
          console.error('Error checking team sites:', error);
          setHasSites(false);
        }
      );

    return () => unsubscribe();
  }, [teamId]);

  return hasSites;
}

